'use client';

import { Broker } from '@habity/types';
import { createClient } from '~/lib/providers/supabase/client';
import { useState } from 'react';
import {
  getAvatarTransformOptions,
  getAvatarUrl,
} from '~/lib/providers/supabase/avatars';

export function useBrokerImage(broker: Broker) {
  const supabase = createClient();

  const [isImageMissing, setIsImageMissing] = useState<boolean>(false);

  // Check if broker has a custom avatar_url (e.g., for shark tank broker)
  const customAvatarUrl = (broker as any)?.avatar_url;
  
  const avatarUrl = customAvatarUrl || getAvatarUrl(
    supabase,
    'brokers',
    broker?.id,
    '.png',
    getAvatarTransformOptions('brokerProfile'),
    broker?.email as string,
    broker?.cloudflare_image_id
  );

  return {
    avatarUrl,
    isImageMissing,
    setIsImageMissing,
  };
}
